// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OrganizationConfigurationForm_ConfigurationFragment = { __typename?: 'OrganizationApplicationConfiguration', id: string, allowUserPresentationTemplates: boolean, collaboratorDomainAllowList?: Array<string> | null, disableAdvancedAnalytics: boolean, disableAiCapabilities: boolean, disableAiInsights: boolean, disableRoleManagement: boolean, disclaimerConfigurationOverridesDescendants: boolean, enableEmployeeIdpID: boolean, mcpAccess: Types.McpAccess, requirePresentationApproval: Types.PresentationApprovalRequirement, smartReviewEnabled: boolean, maxSessionDuration: Types.OrganizationApplicationConfigurationMaxSessionDuration, userSessionInactivityTimeout: Types.OrganizationApplicationConfigurationUserSessionInactivityTimeout };

export type OrganizationConfigurationFormQueryVariables = Types.Exact<{
  luminaryOrganizationID: Types.Scalars['ID']['input'];
}>;


export type OrganizationConfigurationFormQuery = { __typename?: 'Query', organizationApplicationConfigurations: { __typename?: 'OrganizationApplicationConfigurationConnection', edges?: Array<{ __typename?: 'OrganizationApplicationConfigurationEdge', node?: (
        { __typename?: 'OrganizationApplicationConfiguration' }
        & OrganizationConfigurationForm_ConfigurationFragment
      ) | null } | null> | null } };

export type UpdateOrganizationConfigurationFormMutationVariables = Types.Exact<{
  input: Types.AugmentedUpdateOrganizationApplicationConfigurationInput;
}>;


export type UpdateOrganizationConfigurationFormMutation = { __typename?: 'Mutation', updateOrganizationApplicationConfiguration: (
    { __typename?: 'OrganizationApplicationConfiguration' }
    & OrganizationConfigurationForm_ConfigurationFragment
  ) };

export const Operations = {
  Query: {
    OrganizationConfigurationForm: 'OrganizationConfigurationForm' as const
  },
  Mutation: {
    UpdateOrganizationConfigurationForm: 'UpdateOrganizationConfigurationForm' as const
  },
  Fragment: {
    OrganizationConfigurationForm_configuration: 'OrganizationConfigurationForm_configuration' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const OrganizationConfigurationForm_ConfigurationFragmentDoc = gql`
    fragment OrganizationConfigurationForm_configuration on OrganizationApplicationConfiguration {
  id
  allowUserPresentationTemplates
  collaboratorDomainAllowList
  disableAdvancedAnalytics
  disableAiCapabilities
  disableAiInsights
  disableRoleManagement
  disclaimerConfigurationOverridesDescendants
  enableEmployeeIdpID
  mcpAccess
  requirePresentationApproval
  smartReviewEnabled
  maxSessionDuration
  userSessionInactivityTimeout
}
    `;
export const OrganizationConfigurationFormDocument = gql`
    query OrganizationConfigurationForm($luminaryOrganizationID: ID!) {
  organizationApplicationConfigurations(
    where: {luminaryOrganizationID: $luminaryOrganizationID}
    first: 1
  ) {
    edges {
      node {
        ...OrganizationConfigurationForm_configuration
      }
    }
  }
}
    ${OrganizationConfigurationForm_ConfigurationFragmentDoc}`;

/**
 * __useOrganizationConfigurationFormQuery__
 *
 * To run a query within a React component, call `useOrganizationConfigurationFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationConfigurationFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationConfigurationFormQuery({
 *   variables: {
 *      luminaryOrganizationID: // value for 'luminaryOrganizationID'
 *   },
 * });
 */
export function useOrganizationConfigurationFormQuery(baseOptions: Apollo.QueryHookOptions<OrganizationConfigurationFormQuery, OrganizationConfigurationFormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationConfigurationFormQuery, OrganizationConfigurationFormQueryVariables>(OrganizationConfigurationFormDocument, withFetchPolicyContext(options));
      }
export function useOrganizationConfigurationFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationConfigurationFormQuery, OrganizationConfigurationFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationConfigurationFormQuery, OrganizationConfigurationFormQueryVariables>(OrganizationConfigurationFormDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useOrganizationConfigurationFormSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrganizationConfigurationFormQuery, OrganizationConfigurationFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganizationConfigurationFormQuery, OrganizationConfigurationFormQueryVariables>(OrganizationConfigurationFormDocument, withFetchPolicyContext(options));
        }
export type OrganizationConfigurationFormQueryHookResult = ReturnType<typeof useOrganizationConfigurationFormQuery>;
export type OrganizationConfigurationFormLazyQueryHookResult = ReturnType<typeof useOrganizationConfigurationFormLazyQuery>;
export type OrganizationConfigurationFormSuspenseQueryHookResult = ReturnType<typeof useOrganizationConfigurationFormSuspenseQuery>;
export type OrganizationConfigurationFormQueryResult = Apollo.QueryResult<OrganizationConfigurationFormQuery, OrganizationConfigurationFormQueryVariables>;
export const UpdateOrganizationConfigurationFormDocument = gql`
    mutation UpdateOrganizationConfigurationForm($input: AugmentedUpdateOrganizationApplicationConfigurationInput!) {
  updateOrganizationApplicationConfiguration(input: $input) {
    ...OrganizationConfigurationForm_configuration
  }
}
    ${OrganizationConfigurationForm_ConfigurationFragmentDoc}`;
export type UpdateOrganizationConfigurationFormMutationFn = Apollo.MutationFunction<UpdateOrganizationConfigurationFormMutation, UpdateOrganizationConfigurationFormMutationVariables>;

/**
 * __useUpdateOrganizationConfigurationFormMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationConfigurationFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationConfigurationFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationConfigurationFormMutation, { data, loading, error }] = useUpdateOrganizationConfigurationFormMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationConfigurationFormMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationConfigurationFormMutation, UpdateOrganizationConfigurationFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationConfigurationFormMutation, UpdateOrganizationConfigurationFormMutationVariables>(UpdateOrganizationConfigurationFormDocument, options);
      }
export type UpdateOrganizationConfigurationFormMutationHookResult = ReturnType<typeof useUpdateOrganizationConfigurationFormMutation>;
export type UpdateOrganizationConfigurationFormMutationResult = Apollo.MutationResult<UpdateOrganizationConfigurationFormMutation>;
export type UpdateOrganizationConfigurationFormMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationConfigurationFormMutation, UpdateOrganizationConfigurationFormMutationVariables>;